enum NetworkAvailabilityMessage {
  description = "Some app features may not work as expected.",
  title = "No internet connection detected",
}

export { NetworkAvailabilityMessage };
